import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=5594f079&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5594f079",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5594f079')) {
      api.createRecord('5594f079', component.options)
    } else {
      api.reload('5594f079', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=5594f079&scoped=true&", function () {
      api.rerender('5594f079', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Z0c27ByoltyX/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports